import { render, staticRenderFns } from "./FullPageSidebar.vue?vue&type=template&id=49897e0c&scoped=true&"
import script from "./FullPageSidebar.vue?vue&type=script&lang=js&"
export * from "./FullPageSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49897e0c",
  null
  
)

export default component.exports